import { render, staticRenderFns } from "./EventBox.vue?vue&type=template&id=656ae041&scoped=true&"
import script from "./EventBox.vue?vue&type=script&lang=js&"
export * from "./EventBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ae041",
  null
  
)

export default component.exports